import { render, staticRenderFns } from "./MessagesApprovedList.vue?vue&type=template&id=03be2c7f&"
import script from "./MessagesApprovedList.vue?vue&type=script&lang=js&"
export * from "./MessagesApprovedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports